var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailClinic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23174_113001",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23174_113001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33268 16.6667C2.87435 16.6667 2.48199 16.5035 2.1556 16.1771C1.82921 15.8507 1.66602 15.4583 1.66602 15V4.99999C1.66602 4.54166 1.82921 4.1493 2.1556 3.82291C2.48199 3.49652 2.87435 3.33333 3.33268 3.33333H16.666C17.1243 3.33333 17.5167 3.49652 17.8431 3.82291C18.1695 4.1493 18.3327 4.54166 18.3327 4.99999V15C18.3327 15.4583 18.1695 15.8507 17.8431 16.1771C17.5167 16.5035 17.1243 16.6667 16.666 16.6667H3.33268ZM9.99935 10.8333L3.33268 6.66666V15H16.666V6.66666L9.99935 10.8333ZM9.99935 9.16666L16.666 4.99999H3.33268L9.99935 9.16666ZM3.33268 6.66666V4.99999V15V6.66666Z",
    fill: "#475467"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailClinic);
export default __webpack_public_path__ + "static/media/email-clinic.bc83958d9980b5709ccee18d341d27a2.svg";
export { ForwardRef as ReactComponent };